module.exports = __webpack_public_path__ + "img/oneRed.b87de2bb.jpg";